"use client";

import RepAI from "@repai/widget";
import { useEffect } from "react";

export const RepaiScript = () => {
  useEffect(() => {
    RepAI("init", "275fa107fbe747c6b23a237a9b82ef18");
  }, []);

  return null;
};
